<div class="content-wrapper row  container-xxl p-0">
    <div class="content-body col-md-12">
        <loader *ngIf="showLoader"> </loader>
        <div class="card invoice-preview-wrapper" >
            <div class="card-body invoice-preview" *ngIf="(((paymentMode == 'NB' || paymentMode == 'TPV' ||  paymentMode == 'UPI') && paymentStatus == 'PENDING') || (orderType == 'INSURANCE' || orderType == 'ESIM' || orderType == 'LOUNGE' || orderType == 'XPLORER_CARD')|| xplorerOrderDetail)">

                <img src="assets/images/failure.gif" style="height:60px;margin:auto;display:block">

                <div class="row">
                    <div class="col-md-12 text-center fw-600 mt-20">Apologies</div>
                    <div class="col-md-12 text-center mt-10">There seems to be an issue.</div>
                    <div class="col-md-6 offset-md-3 text-center">Please contact customer care at <a class="card-subtitle text-black mb-1" href="tel:8976707222" style="color : #0062ff">+91-8976707222 </a> or <a class="card-subtitle text-black  mb-1" href="mailto:customersupport@wsfx.in" style="color : #0062ff">customersupport@wsfx.in</a>                        and we will reach out to you immediately.!</div>
                </div>
                <div class="row" *ngIf="orderType == 'FOREX_ORDER' && !xplorerOrderDetail">
                    <div class="col-md-12">
                        <div class="p-15">
                            <div class="text-center text-black fw-600 mb-30">Order ID : {{ orderDetails?.orderId }}
                            </div>
                            <div class="row mb-10">
                                <div class="col-md-6 col-6 fw-600 fs-13 text-black">{{ (orderDetails?.invoice?.xplorerCardTotalBillableAmount && orderDetails?.invoice?.xplorerCardTotalBillableAmount != 0) ? 'Forex Amount' : 'Amount' }} </div>
                                <div class="col-md-6 col-6 text-right fw-600 fs-13 text-black">₹ {{orderDetails?.invoice?.billableAmountString}}
                                </div>
                            </div>
                            <!-- <div class="row  mb-10">
                                <div class="col-md-6 col-6 fs-12 text-black"> Forex Margin</div>
                                <div class="col-md-6 col-6 text-right fs-12 text-black">₹ {{forexMarginString}}
                                </div>
                            </div> -->
                            <div class="row  mb-10" *ngIf="orderDetails?.invoice?.totalHandlingChargesString != '0' && orderDetails?.invoice?.totalHandlingChargesString != '0.0' && orderDetails?.invoice?.totalHandlingChargesString != '0.00'">
                                <div class="col-md-6 col-6 fs-12 text-black">Service Charges</div>
                                <div class="col-md-6 col-6 text-right fs-12 text-black">₹ {{orderDetails?.invoice?.totalHandlingChargesString}}
                                </div>
                            </div>
                            <div class="row mb-10">
                                <div class="col-md-6 col-6 fs-12 text-black">GST</div>
                                <div class="col-md-6 col-6 text-right fs-12 text-black">₹ {{orderDetails?.invoice?.totalTaxesString}}
                                </div>
                            </div>
                            <div class="row mb-10">
                                <div class="col-md-6 col-6 fs-12 text-black">TCS({{ orderDetails?.tcs?.tcsPercentageString }}%)
                                </div>
                                <div class="col-md-6 col-6 text-right fs-12 text-black">
                                    ₹ {{ orderDetails?.tcs?.tcsAmountString }}</div>
                            </div>

                            <div class="row mb-10" *ngIf="orderDetails?.invoice?.totalDiscount != '0'">
                                <div class="col-md-6 col-6 fs-13 text-black">Applied coupon code</div>
                                <div class="col-md-6 col-6 text-right fs-13  text-black">
                                    - ₹ {{orderDetails?.invoice?.totalDiscount}}
                                </div>
                            </div>
                            <div class="row mb-10" *ngIf="orderDetails?.redeemedPoints != '0'">
                                <div class="col-md-6 col-6 fs-13 text-black">Redeemed points</div>
                                <div class="col-md-6 col-6 text-right fs-13  text-black">
                                    - ₹ {{orderDetails?.redeemedPoints}}
                                </div>
                            </div>


                            <div class="row mb-10" *ngIf="orderDetails?.invoice?.xplorerCardDetails?.kitFee && orderDetails?.invoice?.xplorerCardDetails?.kitFee != '0'">
                                <div class="col-md-6 col-6 fs-13 text-black">Kit Free</div>
                                <div class="col-md-6 col-6 text-right fs-13  text-black">
                                    ₹ {{ orderDetails?.invoice?.xplorerCardDetails?.kitFee }}
                                </div>
                            </div>
                            <div class="row mb-10" *ngIf="orderDetails?.invoice?.xplorerCardDetails?.gst && orderDetails?.invoice?.xplorerCardDetails?.gst != '0'">
                                <div class="col-md-6 col-6 fs-13 text-black">Kit GST</div>
                                <div class="col-md-6 col-6 text-right fs-13  text-black">
                                    ₹ {{ orderDetails?.invoice?.xplorerCardDetails?.gst }}
                                </div>
                            </div>


                            <div class="row mb-10">
                                <div class="col-md-6 col-6 fs-13 text-black">Total Amount</div>
                                <div class="col-md-6 col-6 text-right fs-13  text-black">
                                    ₹ {{this.orderDetails?.invoice?.totalBillAmountString}}
                                </div>
                            </div>

                            <div class="row mb-10">
                                <div class="col-md-6 col-6 fs-13 fw-600 text-black">Amount Paid </div>
                                <!-- <div class="col-md-6 col-6 text-right fs-13 fw-600 text-black">₹ {{ (orderDetails?.invoice?.xplorerCardTotalBillableAmount && orderDetails?.invoice?.xplorerCardTotalBillableAmount != 0) ? orderDetails?.invoice?.xplorerCardTotalBillableAmountString : orderDetails?.invoice?.totalBillAmountString }}
                                </div> -->
                                 <div class="col-md-6 col-6 text-right fs-13 fw-600 text-black">₹ {{  orderDetails?.invoice?.totalPaymentReceivedString }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="orderType == 'INSURANCE'">
                    <div class="col-md-12">
                        <div class="p-15">
                            <div class="text-center text-black fw-600 mb-30">Order ID : {{ orderId }}
                            </div>
                            <div class="row mb-10">
                                <div class="col-md-6 col-6 fw-600 fs-13 text-black">Plan</div>
                                <div class="col-md-6 col-6 text-right fw-600 fs-13 text-black"> {{ insurancePlan }}
                                </div>
                            </div>
                            <div class="row  mb-10">
                                <div class="col-md-6 col-6 fs-12 text-black">Total Amount</div>
                                <div class="col-md-6 col-6 text-right fs-12 text-black">₹ {{ insuranceDetails?.totalPayableAmount }}
                                </div>
                            </div>

                            <!-- <div class="row mb-10">
                                <div class="col-md-6 col-6 fs-13 text-black">Total Amount</div>
                                <div class="col-md-6 col-6 text-right fs-13  text-black">
                                    ₹ {{this.orderDetails?.invoice?.totalBillAmountString}}
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="orderType == 'ESIM' || orderType == 'LOUNGE'">
                    <div class="col-md-12">
                        <div class="p-15">
                            <div class="text-center text-black fw-600 mb-30">Order ID : {{ orderId }}
                            </div>
                            <div class="row mb-10" *ngIf="orderType == 'ESIM'">
                                <div class="col-md-6 col-6 fw-600 fs-13 text-black">Package Name</div>
                                <div class="col-md-6 col-6 text-right fw-600 fs-13 text-black"> {{ orderDetails?.zetexaPackage?.packageName }}
                                </div>
                            </div>
                            <div class="row mb-10">
                                <div class="col-md-6 col-6 fw-600 fs-13 text-black">Payable Amount</div>
                                <div class="col-md-6 col-6 text-right fw-600 fs-13 text-black"> {{ orderDetails?.payableAmount }}
                                </div>
                            </div>
                            <div class="row mb-10">
                                <div class="col-md-6 col-6 fw-600 fs-13 text-black">Payment Status</div>
                                <div class="col-md-6 col-6 text-right fw-600 fs-13 text-black"> {{ orderDetails?.paymentStatus }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="orderType == 'XPLORER_CARD'">
                    <div class="col-md-12">
                        <div class="p-15">
                            <!-- <div class="text-center text-black fw-600 mb-30">Order ID : {{ orderId }}
                            </div> -->
                            <div class="row mb-10 text-center">
                                <div class="col-md-6 col-6 fw-600 fs-13 text-black text-right">Order ID: </div>
                                <div class="col-md-6 col-6 fw-600 fs-13 text-black text-left"> {{ orderId }}
                                </div>
                            </div>
                            <div class="row mb-10 text-center">
                                <div class="col-md-6 col-6 fw-600 fs-13 text-black text-right">Payable Amount: </div>
                                <div class="col-md-6 col-6 fw-600 fs-13 text-black text-left"> {{ orderDetails?.totalAmount }}
                                </div>
                            </div>
                            <div class="row mb-10 text-center">
                                <div class="col-md-6 col-6 fw-600 fs-13 text-black text-right">Payment Status: </div>
                                <div class="col-md-6 col-6 fw-600 fs-13 text-black text-left"> {{ orderDetails?.status }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="xplorerOrderDetail">
                    <div class="currency-panel-box-wrapper col-md-6 offset-md-3 mb-30 mt-20">
                    <div class="xplorer-breakup-wrapper">
                        <div class="table-responsive amout-breakup-bg tansaction-breakup">
                            <table class="table table-condensed table-borderless  fs-12">
                            <caption class="visually-hidden">Xplorer Kit deatils</caption>
                                <thead class="visually-hidden">
                                    <tr>
                                    <th scope="col" colspan="4"><span></span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style="background-color: #E8E8E8;">
                                        <td class="thick-line text-black fw-600" colspan="4">
                                            <div class="d-flex flex-row">
                                                <div class="breakup-forex-icon"><img src="assets/images/icon/Card details.png" alt="card icons" /></div><span>Xplorer Card Details</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="no-line " colspan="3"><strong>Kit Fee : </strong></td>
                                        <td class="no-line text-right">₹ {{ orderDetails?.invoice?.xplorerCardDetails?.kitFee || xplorerOrderDetail?.kitFee }} </td>
                                    </tr>
                                    <tr>
                                        <td class="no-line " colspan="3"><strong>GST</strong></td>
                                        <td class="no-line text-right">₹ {{ orderDetails?.invoice?.xplorerCardDetails?.gst || xplorerOrderDetail?.gst }} </td>
                                    </tr>
                                    <tr style="border-top:1px solid #EBEBEB; background:#E8E8E8;">
                                        <td class="no-line text-black fw-800 pt-10" colspan="3">Total Kit Amount</td>
                                        <td class="no-line text-right text-black fw-800 pt-10"> ₹ {{ orderDetails?.invoice?.xplorerCardDetails?.totalAmount || xplorerOrderDetail?.totalAmount }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </div>
                </div>




                <div class="row mb-30">
                    <div class="col-md-2">
                        <button type="button" rippleEffect class="btn btn-primary fs-12" (click)="goToOrderDetails()">Order Details</button>
                    </div>
                    <div class="col-md-10 text-right" *ngIf="orderType == 'FOREX_ORDER'">
                        <button type="button" rippleEffect class="btn btn-primary fs-12" (click)="retryPayment()">Retry
                            Now</button>
                    </div>
                </div>
            </div>
        </div>


    </div>
</div>